module.exports = __webpack_public_path__ + "img/003.60e317a0.png";